// EditListing.jsx
// Main component for editing existing listings

import React from 'react';
import { styles } from './styles';
import useEditListing from './useEditListing';
import LoadingState from './LoadingState';
import EditListingForm from './EditListingForm';

// Edit Icon SVG
const EditIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const EditListing = () => {
  const {
    listing,
    loading,
    updating,
    previews,
    updateListingField,
    handleRemoveImage,
    handleNewImages,
    handleUpdate
  } = useEditListing();

  if (loading) {
    return <LoadingState />;
  }

  if (!listing) {
    return null;
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        <div style={styles.headerSection}>
          <div style={styles.iconWrapper}>
            <EditIcon />
          </div>
          <h1 style={styles.heading}>Edit Listing</h1>
          <p style={styles.subheading}>Update your listing details and images</p>
        </div>
        
        <EditListingForm
          listing={listing}
          updating={updating}
          previews={previews}
          onFieldChange={updateListingField}
          onRemoveImage={handleRemoveImage}
          onNewImages={handleNewImages}
          onSubmit={handleUpdate}
        />
      </div>
    </div>
  );
};

export default EditListing;